import { render } from "./DeleteAccountView.vue?vue&type=template&id=e3c26a88&scoped=true"
import script from "./DeleteAccountView.vue?vue&type=script&lang=js"
export * from "./DeleteAccountView.vue?vue&type=script&lang=js"

import "./DeleteAccountView.vue?vue&type=style&index=0&id=e3c26a88&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c26a88"]])

export default __exports__